<template lang="pug">
  .simpleModel
    vue-headful(
      :title="title"
    )
    el-container(v-if="!mobile")
      el-aside
          el-row(justify="center" type="flex")
            el-col
              .scenarioSelection
                el-radio-group(v-model="financialAssumptionsSwitch")
                  el-row
                    el-radio-button(label="Base Case") Base Case
                  el-row
                    el-radio-button(label="Spot Case") Spot Prices
                  el-row
                    el-radio-button(label="User Case") User Case
          el-row
            el-col
              h3 Inputs
              el-popover(
                placement="right"
                v-model='isOpenFinancial'
                trigger="click"
               )
                .financial-inputs(v-if="loaded === true")
                  financial-inputs(
                    :financialAssumptionsSwitch="financialAssumptionsSwitch"
                    :financialInputs="financialInputs"
                    :baseCaseFinancialAssumptions="baseCaseFinancialAssumptions"
                    @switchChange="financialAssumptionsSwitch = $event"
                  )
                el-button(slot="reference") Financial
                  i(class="el-icon-arrow-down el-icon--right")
              el-divider
              el-popover(
                placement="right"
                v-model='isOpenTechnical'
                trigger="click"
                width="400"
              )
                .technical-inputs(v-if="loaded === true")
                  technical-inputs(
                    :technicalAssumptionsSwitch="technicalAssumptionsSwitch"
                    :technicalInputs="technicalInputs"
                    :baseCaseTechnicalAssumptions="baseCaseTechnicalAssumptions"
                    @switchChange="technicalAssumptionsSwitch = $event"
                  )
                el-button(slot="reference") Technical
                  i(class="el-icon-arrow-down el-icon--right")
              el-row
                h3 Settings
                el-radio-group(
                  v-model="viewSwitch"
                  size="small"
                )
                  el-radio-button(label="Chart")
                  el-radio-button(label="Table")
              el-row(v-if="viewSwitch === 'Chart'")
                  el-radio-group(
                    v-model="chartSwitch"
                    size="small"
                  )
                    el-radio-button(label="Production")
                    el-radio-button(label="CashFlow")
              el-row
                  el-radio-group(
                    v-model="currencySwitch"
                    size="small"
                  )
                    el-radio-button(label="USD")
                    el-radio-button(label="CAD")
              el-row
                  el-radio-group(
                    v-model="accountingSwitch"
                    size="small"
                  )
                    el-radio-button(label="By-Product")
                    el-radio-button(label="Co-Product")
      el-container(direction="vertical").app-container
        el-col(:lg="24" :xl="20")
          .header(v-if="loaded === true")
            h2 {{ baseCase.model.assetName }}
            h4(v-if="baseCase.study.level !== null") {{ baseCase.study.level }} ({{baseCase.study.date | formatDateToMonthYear }})
          .output(v-loading="loading")
            .table(
              v-if="viewSwitch === 'Table'"
            )
              el-table(
                v-loading="tableLoading"
                element-loading-text="Loading..."
                :data="tableData"
              )
                el-table-column(
                  prop="field"
                  width="150"
                )
                el-table-column(
                  prop="units"
                  label="Unit"
                )
                el-table-column(
                  prop="baseCase"
                  label="Base Case"
                )
                el-table-column(
                  prop="spotCase"
                  label="Spot Case"
                )
                el-table-column(
                  prop="userCase"
                  label="User Case"
                )

            .charts(
              v-if="viewSwitch === 'Chart'"
            )
              .chart(v-if="chartSwitch === 'Production'")
                h3 Production and Costs
                .production-chart(v-if="loaded===true")
                  production-chart(
                    height=650
                    :data="userCase.years"
                    :aiscChartField="aiscChartField"
                    :exchangeRate="exchangeRate"
                  )
              .chart(v-if="chartSwitch === 'CashFlow'")
                  h3 After-Tax Cash Flow
                  cash-flow-chart(
                    height=650
                    :data="userCase.years"
                    :exchangeRate="exchangeRate"
                  )
              el-row(:gutter="50" type="flex" justify="center").footer
                el-tag(color="white") After-Tax NPV: ${{ millions(userCase.valuation.npv, true) }} M
                el-tag(color="white") After-Tax IRR: {{ percent(userCase.valuation.irr, false) }}
          el-row(type="flex" v-if="loaded&!mobile" justify="end")
            a(href="https://vrify.com/")
              img.powered(src='../assets/powered_by_vrify.png')
    .mobile-text(v-if="mobile")
      el-row(type="flex")
      p Dynamic Model powered by VRIFY is not available on mobile.  Please visit this page on an iPad, laptop or desktop computer.
      el-divider
      el-row(type="flex")
        a(href="https://vrify.com/")
          img.mobile-powered(src='../assets/powered_by_vrify.png')

</template>

<script>
import Slider from '@/components/slider'
import CashFlowChart from '../components/CashFlowChart'
import ProductionChart from '../components/ProductionChart'
import TechnicalInputs from '../components/TechnicalInputs'
import FinancialInputs from '../components/FinancialInputs'
import modelMixin from '../mixins/modelMixin'

export default {
  name: 'home',
  components: { TechnicalInputs, FinancialInputs, CashFlowChart, ProductionChart, Slider },
  mixins: [modelMixin],
  data: function () {
    return {}
  },
  computed: {
    mobile () {
      return window.innerWidth <= 450
    }

  }
}
</script>

<style>
.simpleModel {
  background-color: white;
}

.simpleModel .tooltip {
  font-family: sans-serif;
}

.simpleModel p {
  margin-bottom: 0px !important;
}

.simpleModel h1 {
  font-size: 40px;
  margin-bottom: 0px;
}

.simpleModel h2 {
  font-size: 25px;
  font-weight: bold;
  margin-bottom: 0px;
}

.simpleModel h3 {
  font-size: 20px;
}

.simpleModel h4 {
  color: #555;
  font-weight: 100;
  font-size: 18px;
  margin-top: 2px;
}

.simpleModel .el-radio-group {
  margin-bottom: 10px;
  margin-right: 5px;
}

.simpleModel .el-tag {
  border-color: white;
  margin-left: 30px;
  margin-right: 30px;
  font-size: 20px;
  padding-top: 20px;
  padding-bottom: 12px;
  padding-right: 1% !important;
  padding-left: 1% !important;
  vertical-align: middle;
  display: block;
  height: 60px;
  line-height: 14px;
}

.simpleModel .el-divider {
  width: 100%;
  background-color: white;
  margin-top: 5px;
  margin-bottom: 5px;
}

.simpleModel .header {
  margin-top: 20px;
  height: 50px;
}

.simpleModel .table {
  margin-top: 50px;
}

.simpleModel .scenarioSelection .el-radio-group {
  margin-top: 40px;
}

.simpleModel .scenarioSelection .el-radio-button {
  margin-top: 30px;
  margin-bottom: 30px;
}

.simpleModel .scenarioSelection .el-radio-button .el-radio-button__inner {
  padding-right: 20px;
  padding-left: 20px;
  padding-bottom: 20px;
  padding-top: 20px;
}

.simpleModel .el-aside {
  padding-left: 30px;
  padding-right: 10px;
}

.simpleModel .app-container {
  padding-left: 10px;
  padding-right: 30px;
  margin-right: 30px;
}

.simpleModel .powered {
  padding-top: 20px;
  height: 30px;
  padding-right: 20%;
}

.simpleModel .mobile-powered {
  padding-top: 20px;
  height: 30px;
}

.simpleModel .mobile-text {
  width: 100%;
  margin-left: 5px;
}

@media screen and (max-width: 1366px) {
  .tooltip {
    display: none;
  }
}
</style>
